"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.narrow = narrow;
function narrow(value) {
    return value;
}
//# sourceMappingURL=narrow.js.map